/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleLandingPageFunnelRowData
 */
export interface GoogleLandingPageFunnelRowData {
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    urlKey?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    host?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    query?: string;
    /**
     * 
     * @type {GoogleLandingPageFunnelRowDataJoinStatusEnum}
     * @memberof GoogleLandingPageFunnelRowData
     */
    joinStatus?: GoogleLandingPageFunnelRowDataJoinStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    searchConsoleClicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    searchConsoleImpressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    searchConsoleCtr?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    searchConsolePosition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    ga4Sessions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    ga4EngagedSessions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    ga4KeyEvents?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    ga4Purchases?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelRowData
     */
    ga4Revenue?: string;
}


/**
 * @export
 */
export const GoogleLandingPageFunnelRowDataJoinStatusEnum = {
    Matched: 'matched',
    SearchConsoleOnly: 'search-console-only',
    Ga4Only: 'ga4-only'
} as const;
export type GoogleLandingPageFunnelRowDataJoinStatusEnum = typeof GoogleLandingPageFunnelRowDataJoinStatusEnum[keyof typeof GoogleLandingPageFunnelRowDataJoinStatusEnum];


/**
 * Check if a given object implements the GoogleLandingPageFunnelRowData interface.
 */
export function instanceOfGoogleLandingPageFunnelRowData(value: object): value is GoogleLandingPageFunnelRowData {
    return true;
}

export function GoogleLandingPageFunnelRowDataFromJSON(json: any): GoogleLandingPageFunnelRowData {
    return GoogleLandingPageFunnelRowDataFromJSONTyped(json, false);
}

export function GoogleLandingPageFunnelRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleLandingPageFunnelRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'urlKey': json['urlKey'] == null ? undefined : json['urlKey'],
        'host': json['host'] == null ? undefined : json['host'],
        'path': json['path'] == null ? undefined : json['path'],
        'query': json['query'] == null ? undefined : json['query'],
        'joinStatus': json['joinStatus'] == null ? undefined : json['joinStatus'],
        'searchConsoleClicks': json['searchConsoleClicks'] == null ? undefined : json['searchConsoleClicks'],
        'searchConsoleImpressions': json['searchConsoleImpressions'] == null ? undefined : json['searchConsoleImpressions'],
        'searchConsoleCtr': json['searchConsoleCtr'] === undefined ? undefined : json['searchConsoleCtr'] === null ? null : json['searchConsoleCtr'],
        'searchConsolePosition': json['searchConsolePosition'] === undefined ? undefined : json['searchConsolePosition'] === null ? null : json['searchConsolePosition'],
        'ga4Sessions': json['ga4Sessions'] == null ? undefined : json['ga4Sessions'],
        'ga4EngagedSessions': json['ga4EngagedSessions'] == null ? undefined : json['ga4EngagedSessions'],
        'ga4KeyEvents': json['ga4KeyEvents'] == null ? undefined : json['ga4KeyEvents'],
        'ga4Purchases': json['ga4Purchases'] == null ? undefined : json['ga4Purchases'],
        'ga4Revenue': json['ga4Revenue'] == null ? undefined : json['ga4Revenue'],
    };
}

export function GoogleLandingPageFunnelRowDataToJSON(json: any): GoogleLandingPageFunnelRowData {
    return GoogleLandingPageFunnelRowDataToJSONTyped(json, false);
}

export function GoogleLandingPageFunnelRowDataToJSONTyped(value?: GoogleLandingPageFunnelRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'urlKey': value['urlKey'],
        'host': value['host'],
        'path': value['path'],
        'query': value['query'],
        'joinStatus': value['joinStatus'],
        'searchConsoleClicks': value['searchConsoleClicks'],
        'searchConsoleImpressions': value['searchConsoleImpressions'],
        'searchConsoleCtr': value['searchConsoleCtr'],
        'searchConsolePosition': value['searchConsolePosition'],
        'ga4Sessions': value['ga4Sessions'],
        'ga4EngagedSessions': value['ga4EngagedSessions'],
        'ga4KeyEvents': value['ga4KeyEvents'],
        'ga4Purchases': value['ga4Purchases'],
        'ga4Revenue': value['ga4Revenue'],
    };
}

